import React from "react";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider, Button, TextField, Radio } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import { blue } from "@material-ui/core/colors";
import Translate from "../../common/functions/translate";
import { ClientModel } from "../../models/client/clientModel";
import LocalClientsService from "../../services/localDataServices/localClientsService";
import { ClientSearchModel } from "../../models/client/clientSearchModel";
import Spinner from "../../common/components/spinner/spinner";
import { ClientLocationModel } from "../../models/client/clientLocationModel";
import Paginator from '../../common/components/paginator/paginator';

interface IProps {
    isOpen: boolean;
    toggle: any;
    clientSelected: any
}

interface IState {
    searchTerm: string;
    clients: Array<ClientModel>;
    searchResults: Array<ClientSearchModel>;
    isLoading: boolean;
    selectedClient: ClientModel;
    from: number;
    numberOfRows: number;
    page: number;
    numberOfPages: number;
    totalRecordsCount: number;

}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%',
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px',
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '90% !important',
                height: 700,
                // minHeight: 700,
                maxHeight: 350,
            },
            paperFullWidth: {
                width: '50%'
            }
        },
    },
    palette: {
        primary: blue
    }
})

class ChooseClientDialog extends React.Component<IProps, IState> {
    localClientsService = new LocalClientsService();

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            searchTerm: '',
            clients: new Array<ClientModel>(),
            searchResults: new Array<ClientSearchModel>(),
            selectedClient: new ClientModel(),
            from: 0,
            numberOfRows: 10,
            page: 1,
            numberOfPages: 1,
            totalRecordsCount: 0
        }
    }

    componentDidMount() {
        this.getClients();
    }

    handleChange = (value) => {
        this.setState({
            searchTerm: value,
            selectedClient: new ClientModel(),
            from: 0,
            page: 1,
        }, () => this.getClients())
    }

    handleSearchBtnClicked = () => {
        this.getClients();
    }

    // getClients = () => {
    //     const { searchTerm, from, numberOfRows } = this.state;

    //     this.setState({
    //         isLoading: true
    //     });

    //     this.localClientsService.filterClients(from, numberOfRows, searchTerm).then(
    //         (result: any) => {
    //             this.setState({
    //                 searchResults: result.clients,
    //                 totalRecordsCount: result.count,
    //                 isLoading: false
    //             });
    //         }
    //     ).catch(error => {
    //         this.setState({
    //             isLoading: false
    //         });
    //         console.log(error);
    //     })
    // }

    getClients = () => {
        const { searchTerm, numberOfRows, page } = this.state;

        let from = (page - 1) * numberOfRows;

        this.setState({
            isLoading: true
        });

        this.localClientsService.filterClients(from, numberOfRows, searchTerm).then(
            (result: any) => {
                this.setState({
                    searchResults: result.clients,
                    totalRecordsCount: result.count,
                    numberOfPages: (result.count % this.state.numberOfRows > 0 ?
                        result.count / this.state.numberOfRows + 1 : result.count / this.state.numberOfRows),
                    isLoading: false
                });
            }
        ).catch(error => {
            this.setState({
                isLoading: false
            });
            console.log(error);
        })
    }

    handleSelectionChange = (selectedSearchResult: ClientSearchModel) => {
        this.setState({
            selectedClient: selectedSearchResult.client
        });
    }

    handleChooseBtnClicked = () => {
        const { searchResults, selectedClient } = this.state;
        let selectedSearchResult = searchResults.find(s => s.client.id === selectedClient.id);

        this.props.clientSelected(selectedSearchResult);
    }

    paginataorClick = (page) => {
        this.setState({ page: page }, () => this.getClients());
    }

    render() {
        const { searchTerm, searchResults, isLoading, selectedClient, numberOfPages, page } = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                <Dialog
                    open={this.props.isOpen}
                    onClose={() => this.props.toggle(false)}
                    fullWidth
                    disableBackdropClick={true}>
                    <Modal.DialogTitle id="customized-dialog-title" onClose={() => this.props.toggle(false)}>{Translate('Client search')}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        {isLoading ? <Spinner /> : null}
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <TextField
                                name="clientData"
                                type="email"
                                label={Translate('Search by name, phone, email')}
                                onChange={(e) => this.handleChange(e.target['value'])}
                                value={searchTerm}
                                style={{ width: 90 + '%', marginRight: 10, marginBottom: 10 }}
                            />
                            <div>
                                <Button variant='contained' style={{ marginTop: 8 }} onClick={this.handleSearchBtnClicked}>
                                    {Translate("Search")}
                                </Button>
                            </div>
                        </div>
                        {searchResults.length === 0
                            ? <div style={{ marginTop: 10, marginBottom: 10 }}>Няма намерени резултати</div>
                            : null}
                        {searchResults.length > 0
                            ? <div>
                                <ul className="list-items">
                                    {searchResults.map((r: ClientSearchModel) => {
                                        return (
                                            <li key={r.client.id} onClick={() => this.handleSelectionChange(r)}>
                                                <div className="item-actions">
                                                    <Radio
                                                        checked={selectedClient.id === r.client.id}
                                                        onChange={e => this.handleSelectionChange(r)}
                                                        color="primary"
                                                    />
                                                </div>
                                                <div className="item-info">
                                                    <div className="item-name">
                                                        {r.client.name}
                                                        {r.client.phone ? `, ${r.client.phone}` : null}
                                                        {r.client.email ? `, ${r.client.email}` : null}
                                                    </div>
                                                    <div className="item-desc">
                                                        {r.locations && r.locations.length > 0
                                                            ? r.locations.map((l: ClientLocationModel) => {
                                                                return (
                                                                    <div key={l.id}>
                                                                        {l.address}
                                                                        {l.municipality ? `, ${l.municipality}` : null}
                                                                        {l.municipality ? `, ${l.disctrict}` : null}
                                                                    </div>
                                                                )
                                                            })
                                                            : null}
                                                    </div>
                                                </div>
                                            </li>
                                        );

                                    })}
                                </ul>
                            </div>
                            : null}
                        {numberOfPages > 1 ?
                            <div style={{ marginBottom: '10px', marginTop: '10px', textAlign: "center" }}>
                                <Paginator numberOfPages={numberOfPages} page={page} paginataorClick={this.paginataorClick} />
                            </div>
                            : null}
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button onClick={() => this.props.toggle(false)} variant="contained" style={{ marginRight: 10 }}>
                                {Translate("Cancel")}
                            </Button>
                            <Button color="primary"
                                variant="contained"
                                disabled={selectedClient.id === undefined || selectedClient.id === 0}
                                onClick={this.handleChooseBtnClicked}>
                                {Translate('Choose')}
                            </Button>
                        </div>
                    </Modal.DialogActions>
                </Dialog>
            </MuiThemeProvider>
        )
    }
}

export default ChooseClientDialog